class AgeConsentForm {
    constructor(monthInput, dayInput, yearInput, consentCheckbox, submitBtn) {
      this.monthInput = document.querySelector(monthInput);
      this.dayInput = document.querySelector(dayInput);
      this.yearInput = document.querySelector(yearInput);
      this.consentCheckbox = document.querySelector(consentCheckbox);
      this.submitBtn = document.querySelector(submitBtn);
  
      this.init();
    }
  
    init() {
      this.submitBtn.disabled = true;
      this.monthInput.addEventListener('input', () => this.validate());
      this.dayInput.addEventListener('input', () => this.validate());
      this.yearInput.addEventListener('input', () => this.validate());
      this.consentCheckbox.addEventListener('change', () => this.validate());
    }
  
    isValidDate(year, month, day) {
      const date = new Date(year, month - 1, day);
      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      );
    }
  
    is21OrOlder(year, month, day) {
      const dob = new Date(year, month - 1, day);
      const today = new Date();
      const age21 = new Date(today.getFullYear() - 21, today.getMonth(), today.getDate());
      return dob <= age21;
    }
  
    validate() {
      const month = parseInt(this.monthInput.value, 10);
      const day = parseInt(this.dayInput.value, 10);
      const year = parseInt(this.yearInput.value, 10);
      const consentGiven = this.consentCheckbox.checked;
  
      if (!month || !day || !year) {
        this.submitBtn.disabled = true;
        document.getElementById('invalid-date-message').classList.add('show');
        return;
      }
      if ( !consentGiven) {
        this.submitBtn.disabled = true;
        document.getElementById('invalid-consent-message').classList.add('show');
        return;
      }
      else{
        document.getElementById('invalid-consent-message').classList.remove('show');
      }
      if (!this.isValidDate(year, month, day)) {
        this.submitBtn.disabled = true;
        document.getElementById('invalid-date-message').classList.add('show');
        return;
      }
  
      if (!this.is21OrOlder(year, month, day)) {
        this.submitBtn.disabled = true;
        document.getElementById('invalid-date-message').classList.add('show');
        return;
      }
      document.getElementById('invalid-date-message').classList.remove('show');
      document.getElementById('invalid-consent-message').classList.remove('show');
      this.submitBtn.disabled = false;
    }
  }